import React from "react";
import HeaderOne from "../Layouts/Headers/HeaderOne";
import InnerPageTitle from "../Helpers/InnerPageTitle";
import ServiceArea from "../HomeOne/ServiceArea"; // This might need adjustments for dynamic links
import FooterOne from "../Layouts/Footers/FooterOne";

function Services() {
  // The Services component mainly serves as a container for the service listing and other related sections
  return (
    <>
      <HeaderOne />
      <main>
        <InnerPageTitle
          title="Naše služby"
          paths={[
            { name: "Domů", path: "/" },
            { name: "Služby", path: "/services" },
          ]}
        />
        {/* The ServiceArea component should be adapted to use dynamic links if it's not already doing so */}
        <ServiceArea className="inner-services-area pt-115 pb-90" />
      </main>
      <FooterOne />
    </>
  );
}

export default Services;
